import { TableRow } from "./constants";

export function transformDataForPivot(apiData: any[]): TableRow[] {
  if (!apiData || apiData.length === 0) return [];

  // Helper to get value or fallback
  const get = (row: any, key: string) => row[key] ?? "";

  // New Acq. row: only for the first month
  const newAcqRow: TableRow = {
    label: "New Acq.",
    users: get(apiData[0], "Users"),
    allocated: get(apiData[0], "Allocate"),
    monthData: apiData?.map((row, idx) => ({
      renewal: idx === 0 ? 0 : "",
      allocation: idx === 0 ? get(row, "Allocation") : "",
      usage: idx === 0 ? get(row, "Usage") : "",
    })),
    bold: true,
  };

  // Dynamic renewal rows: skip the first month
  const renewalRows: TableRow[] = apiData.slice(1)?.map((row, idx) => ({
    label: `Renewal ${row.MonthYear.split("-")[0]}.`,
    users: get(row, "Users"),
    allocated: get(row, "Allocate"),
    monthData: apiData?.map((r, i) => ({
      renewal: i === idx + 1 ? get(r, "Renewal") : 0,
      allocation: i === idx + 1 ? get(r, "Allocation") : 0,
      usage: i === idx + 1 ? get(r, "Usage") : 0,
    })),
  }));

  // Totals row
  const totalsRow: TableRow = {
    label: "Totals",
    // users: "",
    // allocated: "",
    monthData: apiData?.map((row) => ({
      renewal: get(row, "Renewal") || 0,
      allocation: get(row, "Allocation") || 0,
      usage: get(row, "Usage") || 0,
    })),
    bold: true,
    bg: "#d0e7ff",
  };

  // Summary/statistics rows
  const usagePercentRow: TableRow = {
    label: "Usage %",
    monthData: apiData?.map((row) => ({
      renewal: "",
      allocation: "",
      usage: get(row, "USAGE%") !== "" ? `${get(row, "USAGE%")}%` : "",
    })),
    bg: "#ffebee",
  };

  const retentionRow: TableRow = {
    label: "Retention",
    monthData: apiData?.map((row) => ({
      renewal: "",
      allocation: "",
      usage: get(row, "Retention%") !== "" ? `${get(row, "Retention%")}%` : "",
    })),
    bg: "#eaf6ff",
  };

  const renewalOffRow: TableRow = {
    label: "Renewal Off",
    monthData: apiData?.map((row) => ({
      renewal: "",
      allocation: "",
      usage: get(row, "Renewal Off"),
    })),
  };

  const renewalFailedRow: TableRow = {
    label: "Renewal Failed",
    monthData: apiData?.map((row) => ({
      renewal: "",
      allocation: "",
      usage: get(row, "Renewal Failed"),
    })),
  };

  const portOutRow: TableRow = {
    label: "Port Out",
    monthData: apiData?.map((row) => ({
      renewal: "",
      allocation: "",
      usage: get(row, "Port Out"),
    })),
  };

  const planSalesRow: TableRow = {
    label: "Plan Sales Reve.",
    monthData: apiData?.map((row) => ({
      renewal: "",
      allocation: "",
      usage:
        get(row, "Plan Sales Reve") !== ""
          ? `£${get(row, "Plan Sales Reve")}`
          : "",
    })),
  };

  const totalTopupsRow: TableRow = {
    label: "Total Topups Done",
    monthData: apiData?.map((row) => ({
      renewal: "",
      allocation: "",
      usage: get(row, "Total Topups Done"),
    })),
  };
  const topupReve: TableRow = {
    label: "Topup Reve",
    monthData: apiData?.map((row) => ({
      renewal: "",
      allocation: "",
      usage: get(row, "Topup Reve") !== "" ? `£${get(row, "Topup Reve")}` : "",
    })),
  };

  const totalOtherPlansRow: TableRow = {
    label: "Total Any Other Plans Sold",
    monthData: apiData?.map((row) => ({
      renewal: "",
      allocation: "",
      usage: get(row, "Total Any Other Plans Sold"),
    })),
  };

  const otherPlansRenewalRow: TableRow = {
    label: "Other Plans Renewal",
    monthData: apiData?.map((row) => ({
      renewal: "",
      allocation: "",
      usage: get(row, "Other Plans Renewal"),
    })),
  };

  const otherSalesRow: TableRow = {
    label: "Other Sales Reve.",
    monthData: apiData?.map((row) => ({
      renewal: "",
      allocation: "",
      usage:
        get(row, "Other Sales Reve") !== ""
          ? `£${get(row, "Other Sales Reve")}`
          : "",
    })),
  };

  const totalPaymentRow: TableRow = {
    label: "Total Payment Made",
    monthData: apiData?.map((row) => ({
      renewal: "",
      allocation: "",
      usage:
        get(row, "Total Payment Made") !== ""
          ? `£${get(row, "Total Payment Made")}`
          : "",
    })),
  };

  const ltvRow: TableRow = {
    label: "LTV",
    monthData: apiData?.map((row) => ({
      renewal: "",
      allocation: "",
      usage: get(row, "LTV") !== "" ? `£${get(row, "LTV")}` : "",
    })),
    bold: true,
    bg: "#e3f2fd",
  };

  return [
    newAcqRow,
    ...renewalRows,
    totalsRow,
    usagePercentRow,
    retentionRow,
    renewalOffRow,
    renewalFailedRow,
    portOutRow,
    planSalesRow,
    totalTopupsRow,
    topupReve,
    totalOtherPlansRow,
    otherPlansRenewalRow,
    otherSalesRow,
    totalPaymentRow,
    ltvRow,
  ];
}
